/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable prefer-destructuring */
import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';
import MaskedInput from 'react-text-mask';
import customerInputsLength from '../../../constants/customerInputsLength';
import CityHttpService from '../../../services/http/city-http';
import ValidationHttpService from '../../../services/http/validation-http';
import StateService from '../../../services/state';
import { theme, control } from '../../../styles/react-select-config';
import { cepMask } from '../../../utils/masks';
import normalizeString from '../../../utils/strings';
import CountryState from '../../../shared/interfaces/countryState.interface';

const CustomerAddress = (props: any) => {
    const [states, setStates] = useState([] as CountryState[]);
    const [cities, setCities] = useState([]);
    const [isDisabled, setDisabled] = useState<boolean>(false);

    const loadCities = async (state: string) => {
        const response = await CityHttpService.get({ state });

        // eslint-disable-next-line @typescript-eslint/no-shadow
        const cities = response.data.map((obj: any) => {
            return {
                label: obj.name,
                value: obj.code,
            };
        });

        cities.unshift({ name: 'Selecione uma cidade', value: '' });

        setCities(cities);
    };

    const getCitiesByState = async (state: string) => {
        const response = await CityHttpService.get({ state });

        // eslint-disable-next-line @typescript-eslint/no-shadow
        const cities = response.data.map((obj: any) => {
            return {
                label: obj.name,
                value: obj.code,
            };
        });

        cities.unshift({ name: 'Selecione uma cidade', value: '' });

        return cities;
    };

    const handleCepChanges = async (event: any) => {
        const value: any = event.target.value;
        const changes = [{ target: { name: 'addressCep', value } }];

        if (value.replace(/\D/g, '').length === 8) {
            try {
                const data: any = await ValidationHttpService.validateCep(
                    value.replace(/\D/g, ''),
                );

                const street = data.data.street;
                const neighborhood = data.data.neighborhood;

                const state: any = states.find(
                    (item: any) => item.value === data?.data?.state,
                );

                // eslint-disable-next-line @typescript-eslint/no-shadow
                const cities = await getCitiesByState(state.value);

                const city: any = cities.find(
                    (item: any) =>
                        item.label ===
                        normalizeString(data?.data?.city).toUpperCase(),
                );

                changes.push({ target: { name: 'erpState', value: state } });
                changes.push({ target: { name: 'erpCity', value: city } });
                changes.push({
                    target: { name: 'erpCityName', value: city.label },
                });
                changes.push({
                    target: {
                        name: 'addressDescription',
                        value: street.substring(
                            0,
                            customerInputsLength.addressDescription,
                        ),
                    },
                });
                changes.push({
                    target: {
                        name: 'addressNeighborhood',
                        value: neighborhood.substring(
                            0,
                            customerInputsLength.addressNeighborhood,
                        ),
                    },
                });

                setDisabled(true);
            } catch (err) {
                changes.push({ target: { name: 'erpState', value: {} } });
                changes.push({ target: { name: 'erpCity', value: {} } });
                changes.push({ target: { name: 'erpCityName', value: '' } });
                changes.push({
                    target: { name: 'addressDescription', value: '' },
                });
                changes.push({
                    target: { name: 'addressNeighborhood', value: '' },
                });

                setDisabled(false);
            }
        }

        props.handleChanges(changes);
    };

    useEffect(() => {
        const loadErpStates = async () => {
            const results = await StateService.get();

            // eslint-disable-next-line array-callback-return
            results.map((obj: any) => {
                obj.label = obj.name;
                obj.value = obj.code;
            });

            setStates(results);

            if (props.customer.erpState) {
                const uf: any = results.find(
                    (item: any) => item.code === props.customer.erpState,
                );
                // eslint-disable-next-line @typescript-eslint/no-shadow
                const cities = await getCitiesByState(props.customer.erpState);
                const city: any = cities.find(
                    (item: any) =>
                        item.label ===
                        normalizeString(props?.customer?.erpCity).toUpperCase(),
                );

                props.handleChanges([
                    {
                        target: {
                            name: 'erpState',
                            value: {
                                name: uf?.label,
                                code: uf?.value,
                                label: uf?.label,
                                value: uf?.value,
                            },
                        },
                    },
                    {
                        target: {
                            name: 'erpCity',
                            value:
                                props.customer.erpCity &&
                                props.customer.erpCityName
                                    ? {
                                          label: props.customer.erpCityName,
                                          value: props.customer.erpCity,
                                      }
                                    : {
                                          label: city?.label,
                                          value: city?.value,
                                      },
                        },
                    },
                    { target: { name: 'erpCityName', value: city?.label } },
                ]);
            }
        };

        loadErpStates();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!props.customer.erpState) {
            return;
        }

        loadCities(props.customer.erpState.value);
    }, [props.customer.erpState]);

    const handleStateChanges = async (value: any) => {
        props.handleChanges([
            { target: { name: 'erpState', value } },
            { target: { name: 'erpCity', value: null } },
            { target: { name: 'erpCityName', value: null } },
        ]);

        loadCities(value.code);
    };

    const handleCityChanges = async (value: any) => {
        props.handleChanges([
            { target: { name: 'erpCity', value } },
            { target: { name: 'erpCityName', value: value.label } },
        ]);
    };

    return (
        <>
            <Form.Group controlId="formBasicCep">
                <Form.Label>CEP</Form.Label>
                <Form.Control
                    value={props.customer.addressCep}
                    isInvalid={!!props.errors.addressCep}
                    as={MaskedInput}
                    mask={cepMask}
                    onChange={handleCepChanges}
                    name="addressCep"
                    type="text"
                />
                {props.errors.addressCep && (
                    <Form.Control.Feedback type="invalid">
                        {props.errors.addressCep}
                    </Form.Control.Feedback>
                )}
            </Form.Group>

            <Row>
                <Col lg={6} md={12}>
                    <Form.Group controlId="formBasicCep">
                        <Form.Label>Endereço</Form.Label>
                        <Form.Control
                            value={props.customer.addressDescription}
                            isInvalid={!!props.errors.addressDescription}
                            onChange={props.handleChanges}
                            name="addressDescription"
                            type="text"
                            maxLength={customerInputsLength.addressDescription}
                        />
                        {props.errors.addressDescription && (
                            <Form.Control.Feedback type="invalid">
                                {props.errors.addressDescription}
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Col>

                <Col lg={6} md={12}>
                    <Form.Group controlId="formBasicCep">
                        <Form.Label>Número</Form.Label>
                        <Form.Control
                            value={props.customer.addressNumber}
                            isInvalid={!!props.errors.addressNumber}
                            onChange={props.handleChanges}
                            name="addressNumber"
                            type="text"
                            maxLength={5}
                        />
                        {props.errors.addressNumber && (
                            <Form.Control.Feedback type="invalid">
                                {props.errors.addressNumber}
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col lg={6} md={12}>
                    <Form.Group controlId="formBasicState">
                        <Form.Label>Estado</Form.Label>
                        <Select
                            placeholder="Selecione..."
                            noOptionsMessage={() => 'Sem opções'}
                            name="erpState"
                            onChange={handleStateChanges}
                            value={props.customer.erpState}
                            options={states}
                            isMulti={false}
                            styles={{ control }}
                            theme={theme}
                            isDisabled={isDisabled}
                        />
                        {props.errors.erpState && (
                            <Form.Control.Feedback type="invalid">
                                {props.errors.erpState}
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Col>
                <Col lg={6} md={12}>
                    <Form.Group controlId="formBasicCity">
                        <Form.Label>Cidade</Form.Label>
                        <Form.Control
                            style={{ display: 'none' }}
                            isInvalid={!!props.errors.erpCity}
                        />
                        <Select
                            placeholder="Selecione..."
                            noOptionsMessage={() => 'Sem opções'}
                            name="erpCity"
                            onChange={handleCityChanges}
                            value={props.customer.erpCity}
                            options={cities}
                            isMulti={false}
                            styles={{ control }}
                            theme={theme}
                            isDisabled={isDisabled}
                        />
                        {props.errors.erpCity && (
                            <Form.Control.Feedback type="invalid">
                                {props.errors.erpCity}
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Col>

                <Col>
                    <Form.Group controlId="formBasicNeighborhood">
                        <Form.Label>Bairro</Form.Label>
                        <Form.Control
                            disabled={props.isDisabled}
                            isInvalid={!!props.errors.addressNeighborhood}
                            onChange={props.handleChanges}
                            value={props.customer.addressNeighborhood}
                            name="addressNeighborhood"
                            maxLength={customerInputsLength.addressNeighborhood}
                            type="text"
                        />
                        {props.errors.addressNeighborhood && (
                            <Form.Control.Feedback type="invalid">
                                {props.errors.addressNeighborhood}
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Col>

                <Col>
                    <Form.Group controlId="formBasicComplement">
                        <Form.Label>Complemento</Form.Label>
                        <Form.Control
                            disabled={props.isDisabled}
                            isInvalid={!!props.errors.addressComplement}
                            onChange={props.handleChanges}
                            value={props.customer.addressComplement}
                            name="addressComplement"
                            maxLength={customerInputsLength.addressComplement}
                            type="text"
                        />
                        {props.errors.addressComplement && (
                            <Form.Control.Feedback type="invalid">
                                {props.errors.addressComplement}
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Col>
            </Row>
        </>
    );
};

export default CustomerAddress;
